/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartPieA2Icon16Regular = forwardRef('DataChartPieA2Icon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1a.75.75 0 0 0-.75.75V8c0 .414.336.75.75.75h6.25A.75.75 0 0 0 15 8a7.002 7.002 0 0 0-7-7Zm.75 6.25V2.551a5.5 5.5 0 0 1 4.699 4.699H8.75Z" }),
        React.createElement("path", { d: "M5.586 3.058a.75.75 0 0 0-.658-1.348 7 7 0 1 0 9.354 9.377.75.75 0 0 0-1.346-.661 5.5 5.5 0 1 1-7.35-7.368Z" })));
});
